import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_r2robots.png",
      alt: "Estratégias R2 Robots",
    },
    title: "Estratégias Quant e Alfas é com a R2 Robots!",

    // String ou array de strings
    text: [
      "Os desenvolvedores da R2 Robots criam robôs desde 2016 e têm sinais de contas com dinheiro real publicadas desde 2017 sem nunca ter zerado uma conta. Com servidor em nuvem para realizar testes de robustez, utilizam as melhores técnicas Quant e Alfas para evolução contínua. Além disso, nenhuma das estratégias usam a arriscada técnica “Martingale”, ou seja, não aumentam os contratos nas perdas, mantendo o risco das operações o mais baixo possível.",
      "Seguimos a filosofia “Skin in The Game” colocamos capital próprio para testarmos em conta real antes de fornecermos para os clientes.",
    ],
    testimonial: {
      text: "A R2 Robots nasceu para oferecer robôs inovadores e seguros!",
      author: {
        name: "Rafael Puntel Vargens, CEO RF Softwares LTDA - R2 Robots",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias R2 Robots",
    heading: "Estratégias testadas com dinheiro real!",
    subtitle:
      "As estratégias da R2 Robots são testadas em contas reais dos próprios sócios antes de serem disponibilizadas aos clientes.",
  },

  cta: {
    title: "Comece a operar!",
    subtitle: "Ative a R2 Robots na sua conta!",
    buttonText: "Ativar extensão!",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "R2 Robots",
    col1: [
      "A R2 Robots foi criada por um grupo de desenvolvedores para oferecer os melhores robôs para B3 com a tecnologia desenvolvida com muito sucesso pelos seus fundadores desde 2016 no mercado internacional de moedas.",
      "A ideia era trazer o que existe de mais novo em termos de robôs de investimentos, como aperfeiçoamento com uso de estratégias Quant e Alfa.",
    ],
    col2: [
      "Prezamos pela responsabilidade. As estratégias da R2 Robots não usam técnicas de alto risco e nunca param de evoluir, se adaptando às mudanças que ocorrem no mercado financeiro para sempre buscar os melhores resultados. Novas estratégias são testadas com dinheiro real dos próprios sócios, antes que possam ser oferecidas aos clientes.",
    ],
  },

  stats: {
    title: "Números da R2 Robots",
    subtitle:
      "Mais de 08 anos de experiência dos fundadores em desenvolvimento de robôs",
    data: [
      {
        value: "+1k",
        description: "Clientes",
      },
      {
        value: "+60",
        description: "Países",
      },
      {
        value: "+6",
        description: "Anos de sinal ininterrupto",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da R2 Robots?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.lightbulb,
        title: "Inovação",
        description: "Os robôs da R2 Robots usam as técnicas mais inovadoras",
      },
      {
        icon: iconsSet.growth,
        title: "Evolução",
        description:
          "Possuímos servidor próprio na nuvem para testes de robustez focando em melhoria contínua",
      },
      {
        icon: iconsSet.check_verify,
        title: "Testado",
        description: "Testamos em contas reais antes de oferecer aos clientes.",
      },
      {
        icon: iconsSet.chip,
        title: "Automatizado",
        description: "Algoritmos 100% automáticos",
      },
      {
        icon: iconsSet.balance,
        title: "Risco Controlado",
        description: "Não usamos a arriscada técnica “Martingale”",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte",
        description:
          "Possuímos suporte humano e individualizado para configurar o robô.",
      },
      // ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Tenho recomendado a trade2go a todos os amigos e familiares. Os resultados incríveis que obtive superaram minhas expectativas, sem falar no suporte excepcional da equipe que faz toda a diferença. Recomendo demais para quem busca sucesso no mercado financeiro.",
  //     author: "Alexandre Melara",
  //     job: "Consultor",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Graças às estratégias da trade2go, finalmente encontrei uma forma de potencializar meus investimentos com minicontratos eliminando o aspecto emocional.",
  //     author: "Ricardo Silva",
  //     job: "Administrador de Empresas",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
